// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rich-text-container {
   width: auto;
   height: auto;
   overflow: auto;
   display: flex;
   flex-direction: column;
}

.rich-text-container>div {
   display: flex;
   align-items: center;
   padding: var(--padding-sm);
}

.rich-text-container ul {
   list-style: unset;
   padding-left: var(--padding-lg);
}

.rich-text-container li {
   /* overflow-wrap: break-word; */
   overflow: unset;
   white-space: normal;
   
}

.rich-text-container ul ul {
   list-style-type: circle;
}

.rich-text-container ul ul {
   list-style-type: circle;
}

.rich-text-container a {
   margin: 0;
   padding: 0;
}

.rich-text-container strong {
   margin: var(--margin);
   display: flex;
   align-items: center;
}

.rich-text-container i {
   margin: var(--margin);
}

.rich-text-container del {
   margin: var(--margin);
   display: flex; 
   align-items: center; 
}

.rich-text-container em {
   margin: var(--margin);
   display: flex;
   align-items: center;
}

.rich-text-container blockquote {
   border-left: 5px solid #ccc;
   margin: var(--margin);
   padding: var(--padding);
}
/* ECLRichTextViewer calls a bunch of different visualizations. The JS for each vizualzations 
is housed in the Visualizations directory, but the CSS for all of them goes here for now. */

.rich-image-viz {
   width: auto;
   max-width: 100%;
}

.rich-text-container>hr {
   display: block; 
   width: 100%;
}

.rich-text-span {
   padding: var(--padding-sm)
}

.rich-text-container .rich-text-table-container{
   max-width: 100%;
}


@media only screen and (min-width: 360px) and (max-width: 480px) {
   .rich-text-container {
      width: auto;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
      max-width: 85vw;
   }

   .rich-image-viz {
      width: auto;
      max-width: 85vw;
   }

   .comments-list > .rich-text-container {
      width: auto;
      max-width: 65vw;
   }
}

@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {
   .rich-text-container {
      width: auto;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
      max-width: 85vw;
   }

   .rich-image-viz {
      width: auto;
      max-width: 85vw;
   }

   .comments-list > .rich-text-container {
      width: auto;
      max-width: 65vw;
   }
}

/* @media only screen and (min-width: 481px) and (max-width: 600px) {
   .rich-text-container {
      width: auto;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
      max-width: 100vw;
   }

   .rich-image-viz {
      width: auto;
      max-width: 100vw;
   }

   .comments-list > .rich-text-container {
      width: auto;
      max-width: 70vw;
   }
} */`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLRichText/Viewer/ECLRichTextViewer.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,YAAY;GACZ,cAAc;GACd,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,0BAA0B;AAC7B;;AAEA;GACG,iBAAiB;GACjB,+BAA+B;AAClC;;AAEA;GACG,+BAA+B;GAC/B,eAAe;GACf,mBAAmB;;AAEtB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,SAAS;GACT,UAAU;AACb;;AAEA;GACG,qBAAqB;GACrB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,qBAAqB;GACrB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,2BAA2B;GAC3B,qBAAqB;GACrB,uBAAuB;AAC1B;AACA;2FAC2F;;AAE3F;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,cAAc;GACd,WAAW;AACd;;AAEA;GACG;AACH;;AAEA;GACG,eAAe;AAClB;;;AAGA;GACG;MACG,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,eAAe;GAClB;;GAEA;MACG,WAAW;MACX,eAAe;GAClB;;GAEA;MACG,WAAW;MACX,eAAe;GAClB;AACH;;AAEA;GACG;MACG,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,eAAe;GAClB;;GAEA;MACG,WAAW;MACX,eAAe;GAClB;;GAEA;MACG,WAAW;MACX,eAAe;GAClB;AACH;;AAEA;;;;;;;;;;;;;;;;;;;GAmBG","sourcesContent":[".rich-text-container {\r\n   width: auto;\r\n   height: auto;\r\n   overflow: auto;\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.rich-text-container>div {\r\n   display: flex;\r\n   align-items: center;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.rich-text-container ul {\r\n   list-style: unset;\r\n   padding-left: var(--padding-lg);\r\n}\r\n\r\n.rich-text-container li {\r\n   /* overflow-wrap: break-word; */\r\n   overflow: unset;\r\n   white-space: normal;\r\n   \r\n}\r\n\r\n.rich-text-container ul ul {\r\n   list-style-type: circle;\r\n}\r\n\r\n.rich-text-container ul ul {\r\n   list-style-type: circle;\r\n}\r\n\r\n.rich-text-container a {\r\n   margin: 0;\r\n   padding: 0;\r\n}\r\n\r\n.rich-text-container strong {\r\n   margin: var(--margin);\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.rich-text-container i {\r\n   margin: var(--margin);\r\n}\r\n\r\n.rich-text-container del {\r\n   margin: var(--margin);\r\n   display: flex; \r\n   align-items: center; \r\n}\r\n\r\n.rich-text-container em {\r\n   margin: var(--margin);\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.rich-text-container blockquote {\r\n   border-left: 5px solid #ccc;\r\n   margin: var(--margin);\r\n   padding: var(--padding);\r\n}\r\n/* ECLRichTextViewer calls a bunch of different visualizations. The JS for each vizualzations \r\nis housed in the Visualizations directory, but the CSS for all of them goes here for now. */\r\n\r\n.rich-image-viz {\r\n   width: auto;\r\n   max-width: 100%;\r\n}\r\n\r\n.rich-text-container>hr {\r\n   display: block; \r\n   width: 100%;\r\n}\r\n\r\n.rich-text-span {\r\n   padding: var(--padding-sm)\r\n}\r\n\r\n.rich-text-container .rich-text-table-container{\r\n   max-width: 100%;\r\n}\r\n\r\n\r\n@media only screen and (min-width: 360px) and (max-width: 480px) {\r\n   .rich-text-container {\r\n      width: auto;\r\n      height: auto;\r\n      overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .rich-image-viz {\r\n      width: auto;\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comments-list > .rich-text-container {\r\n      width: auto;\r\n      max-width: 65vw;\r\n   }\r\n}\r\n\r\n@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {\r\n   .rich-text-container {\r\n      width: auto;\r\n      height: auto;\r\n      overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .rich-image-viz {\r\n      width: auto;\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comments-list > .rich-text-container {\r\n      width: auto;\r\n      max-width: 65vw;\r\n   }\r\n}\r\n\r\n/* @media only screen and (min-width: 481px) and (max-width: 600px) {\r\n   .rich-text-container {\r\n      width: auto;\r\n      height: auto;\r\n      overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-width: 100vw;\r\n   }\r\n\r\n   .rich-image-viz {\r\n      width: auto;\r\n      max-width: 100vw;\r\n   }\r\n\r\n   .comments-list > .rich-text-container {\r\n      width: auto;\r\n      max-width: 70vw;\r\n   }\r\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
